(() => {
  if (window.PurePatchBundlePurchase) return;
  const readJson = async (url, options) => {
    const response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok || data.status >= 400) {
      throw new Error("This bundle could not be added. Please try again.");
    }
    return data;
  };

  // Preset bundles must go through Loop so orders contain the component SKUs.
  // A normal parent-variant add would bypass bundle grouping and discounts.
  const add = async ({ productId, variantId, planId = 0, expectedPrice }) => {
    const quantity = 1;
    const shopRoot = window.Shopify.routes.root;
    const cdn = "https://cdn.loopwork.co/" + window.Shopify.shop;
    const [store, bundle, cart] = await Promise.all([
      readJson(cdn + "/store.json", { cache: "no-cache" }),
      readJson(cdn + "/presetBundles/" + productId + ".json", { cache: "no-cache" }),
      readJson(shopRoot + "cart.js")
    ]);
    const variant = bundle.variants?.find((item) => Number(item.shopifyId) === variantId);
    const discount = variant?.mappedDiscounts?.find((item) =>
      item.purchaseType === (planId ? "SUBSCRIPTION" : "ONETIME")
    );
    if (!store.hasPresetBundles || !store.presetBundleShopifyProductIds?.includes(productId) ||
        !variant || variant.outOfStock || !variant.mappedProductVariants?.length || !discount ||
        (planId && variant.sellingPlanPrices?.[planId] == null) || !Number.isInteger(quantity) || quantity < 1) {
      throw new Error("This bundle is temporarily unavailable. Please try again.");
    }
    const currentPrice = Math.round(Number(planId ? variant.sellingPlanPrices[planId] : variant.oneTimePrice) * 100);
    const displayedPrice = Number(expectedPrice);
    if (!Number.isFinite(currentPrice) || currentPrice !== displayedPrice) {
      throw new Error("This bundle's price has changed. Please refresh the page before adding it.");
    }
    const transactionUrl = new URL(store.apiUrl.bundleTransaction);
    if (transactionUrl.protocol !== "https:" || !transactionUrl.hostname.endsWith(".loopwork.co")) {
      throw new Error("This bundle could not be added. Please try again.");
    }
    const transaction = await readJson(transactionUrl.href, {
      method: "POST",
      headers: { "Content-Type": "application/json", authorization: store.sentinalAuthToken },
      body: JSON.stringify({
        presetProductShopifyId: productId,
        presetDiscountId: discount.id,
        presetVariantShopifyId: variantId,
        totalQuantity: quantity,
        sellingPlanShopifyId: planId
      })
    });
    const transactionId = transaction.data?.transactionId;
    if (!transactionId) throw new Error("This bundle could not be added. Please try again.");

    let oldDiscounts = {};
    try { oldDiscounts = JSON.parse(cart.attributes?._loopBundleDiscountAttributes || "{}"); } catch {}
    const currentBundleIds = new Set(cart.items.map((item) => item.properties?._bundleId || item.properties?._loopBundleTxnId));
    const bundleDiscounts = Object.fromEntries(Object.entries(oldDiscounts).filter(([id]) => currentBundleIds.has(id)));
    const dummySku = store.preferences?.presetDummySkuEnabled === true;
    bundleDiscounts[transactionId] = {
      discountType: discount.type,
      discountValue: discount.value,
      discountComputedValue: (planId ? discount.sellingPlanComputedDiscounts[planId] : discount.oneTimeDiscount) * (dummySku ? 1 : quantity)
    };
    const nameProperty = store.preferences?.showBundleName ? "bundleName" : "_bundleName";
    const properties = { _isPresetBundleProduct: true, [nameProperty]: bundle.name };
    const items = dummySku ? [{
      id: variantId, quantity,
      ...(planId ? { selling_plan: planId } : {}),
      properties: { ...properties, _loopBundleTxnId: transactionId }
    }] : variant.mappedProductVariants.map((item) => ({
      id: item.shopifyId,
      quantity: item.quantity * quantity,
      ...(planId ? { selling_plan: planId } : {}),
      properties: { ...properties, _bundleId: transactionId }
    }));
    await readJson(shopRoot + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items, attributes: { _loopBundleDiscountAttributes: JSON.stringify(bundleDiscounts) } })
    });
    return transactionId;
  };

  window.PurePatchBundlePurchase = { add };
})();
